import { render, staticRenderFns } from "./CoozzyPinIcon.vue?vue&type=template&id=856a9182&scoped=true"
import script from "./CoozzyPinIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyPinIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyPinIcon.vue?vue&type=style&index=0&id=856a9182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "856a9182",
  null
  
)

export default component.exports